/* ---------- Shop the Staples — bestsellers carousel ----------
 * Two jobs:
 *  1. Chevron prev/next scroll the track ~85% of its visible width (mirrors the
 *     prototype's staplesScroll).
 *  2. "Add to Bag" does a REAL AJAX add of the product's first-available variant
 *     via window.KRGCart (defined in krg-cart.js), which adds the line and
 *     re-renders the drawer through the Section Rendering API — so the free-shipping
 *     gauge, subtotal, and bag count all update — then opens the drawer.
 * Delegated so it works regardless of load order / section re-renders.
 */
(function () {
  'use strict';

  // The section emits this script once per instance, so on a page with multiple
  // carousels it loads more than once. Handlers are document-delegated (one set
  // covers every instance), so guard against re-running — otherwise chevrons
  // double-scroll (cancelling out) and "Add to Bag" would add twice.
  if (window.__krgStaplesInit) return;
  window.__krgStaplesInit = true;

  function trackFor(btn) {
    var section = btn.closest('.krg-staples');
    return section && section.querySelector('[data-krg-staples-track]');
  }

  document.addEventListener('click', function (e) {
    /* ---- chevrons ---- */
    var arrow = e.target.closest('[data-krg-staples-prev], [data-krg-staples-next]');
    if (arrow) {
      var track = trackFor(arrow);
      if (track) {
        var dir = arrow.hasAttribute('data-krg-staples-next') ? 1 : -1;
        track.scrollBy({ left: dir * Math.round(track.clientWidth * 0.85), behavior: 'smooth' });
      }
      return;
    }

    /* ---- add to bag ---- */
    var add = e.target.closest('[data-krg-staple-add]');
    if (add) {
      e.preventDefault();
      if (add.hasAttribute('disabled')) return;
      var vid = add.getAttribute('data-variant-id');
      if (!vid) return;

      // Reuse the exact drawer machinery (re-render + gauge + count) from krg-cart.js.
      if (!(window.KRGCart && typeof window.KRGCart.add === 'function')) {
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        window.location.href = root + 'cart';
        return;
      }

      var label = add.textContent;
      add.setAttribute('disabled', '');
      add.textContent = 'Adding…';
      window.KRGCart.add(vid, 1)
        .then(function () { if (window.KRGCart.open) window.KRGCart.open(); })
        .catch(function () {})
        .then(function () {
          add.removeAttribute('disabled');
          add.textContent = label;
        });
      return;
    }
  });

  /* ---- optional hero "Shop Bestsellers" anchor ----
   * A plain #hash link won't scroll on desktop because Horizon scrolls
   * `.page-wrapper`, not the window (>=990px). Intercept links to this section
   * and scroll the correct scroller.
   */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href$="#shop-the-staples"]');
    if (!a) return;
    var target = document.getElementById('shop-the-staples');
    if (!target) return;
    e.preventDefault();
    var OFFSET = 84; // clear the sticky header
    var pw = document.querySelector('.page-wrapper');
    // `.page-wrapper` carries CSS `scroll-behavior: smooth`, which turns a
    // programmatic scroll into a cancellable animation that the clicked link's
    // focus-scroll then aborts (same gotcha as the Okendo star scroll). Force an
    // instant, non-cancellable jump by overriding scroll-behavior for the assignment.
    if (pw && window.matchMedia('(min-width: 990px)').matches) {
      var top = target.getBoundingClientRect().top - pw.getBoundingClientRect().top + pw.scrollTop - OFFSET;
      var prev = pw.style.scrollBehavior;
      pw.style.scrollBehavior = 'auto';
      pw.scrollTop = Math.max(0, top);
      pw.style.scrollBehavior = prev;
    } else {
      var wtop = target.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop) - OFFSET;
      var root = document.scrollingElement || document.documentElement;
      var prevW = root.style.scrollBehavior;
      root.style.scrollBehavior = 'auto';
      window.scrollTo(0, Math.max(0, wtop));
      root.style.scrollBehavior = prevW;
    }
  });
})();
